import React ,{useState} from 'react'
import Component_Heading from '../component/Component_Heading'
import glipse1 from './images/glipse1.png'
import glipse2 from './images/glipse2.png'
import glipse3 from './images/glipse3.png'
import glipse4 from './images/glipse4.png'
import glipse5 from './images/glipse5.png'
import glipse6 from './images/glipse6.png'
import Websites from './Websites'



export default function Glipse_Work() {

  
        // State to track the currently active tab
        const [activeTab, setActiveTab] = useState('Tab1');
      
        // Handle tab click
        const handleTabClick = (tab) => {
          setActiveTab(tab);
        };

        const renderContent = () => {
            switch (activeTab) {
              case 'Tab1':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse5} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse6} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse4} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse2} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse3} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab1':
                    return (
                        <div className="container main-img-glipse ">
            <div className="row row-cols-4 main-row-glipse ">
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse2} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse3} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse4} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse5} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse6} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse2} alt="" />
                    </div>
                </div>
    
            </div>
    
        </div>
                    );
                    case 'Tab2':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse2} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse6} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse4} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse2} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse5} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse3} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse6} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab3':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab4':
                return (
                        <Websites/>
                );
                case 'Tab5':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab6':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab7':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
                case 'Tab8':
                return (
                    <div className="container main-img-glipse ">
        <div className="row row-cols-4 main-row-glipse ">
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>
            <div className="col col-glipse">
                <div className="img-area">
                    <img src={glipse1} alt="" />
                </div>
            </div>

        </div>

    </div>
                );
            
                case 'Tab9':
                    return (
                        <div className="container main-img-glipse ">
            <div className="row row-cols-4 main-row-glipse ">
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
                <div className="col col-glipse">
                    <div className="img-area">
                        <img src={glipse1} alt="" />
                    </div>
                </div>
    
            </div>
    
        </div>
                    );
            }
            };
  return (
       
 



    <>
    <Component_Heading heading="GLIMPSE OF OUR WORK" para="Take a look at some of our recent design projects that highlight our expertise, creativity, and attention to detail. Each piece demonstrates how we transform ideas into visually engaging designs that inspire, connect, and deliver real impact for every brand.
 "/>

    <div className="contaiiner Glipse_work-tabs-main">
        <div className="tabs-container">
            <ul className="tabs-contain-area">
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab1')} autoFocus>Social Media Posts</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab2')}>Logo Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab3')}>Flyer Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab4')}>Website Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab5')}>Brochure Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab6')}>UI/UX Design</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab7')}>Business Card</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab8')}>Mockups</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab9')}>Others</button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    {renderContent()}
    </>
  )
}
